
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import { mapState } from 'vuex'
export default {
name: 'medical',
props: [],
directives: {
TransferDom
},
components: {
XHeader,
XButton,
Group,
Cell,
Popup
},
data () {
return {
showDate: false,
dateValue: '请选择',
value1: [],
id: '',
preiod: '',
dateArr: [],
notice: {
content: '1、注意饮食对于体检来说在前一天的时候，特别是在饮食方面要特别的注意，注意不可以大吃大喝，对于一些辛辣刺激的食物我们也尽量不要吃，忌烟酒，另外要保证自己的心情愉悦，不可以过度的劳累，早点休息，同时要保证自己的精力充沛，对于一些血压不稳定的患者要避免劳动，保持血压的稳定性',
department: '校医院',
date: ''
},
btnText: '预约'
}
},
computed: {
...mapState({
title: state => state.currentProcedureInfo.name,
studentId: state => state.userInfo.id,
flowId: state => state.flowInfo.flowId,
flowProcedureId: state => state.currentProcedureInfo.flowProcedureId,
procedureId: state => state.currentProcedureInfo.procedureId,
campusCode: state => state.userInfo.campusCode,
parentRouter: state => state.currentProcedureInfo.parentRouter
}),
dateID () {
return this.$route.params.dateId
}
},
watch: {
},
created () {},
mounted () {
this.getTimeSlot()
},
updated () {},
destroyed () {},
methods: {
back () {
setTimeout(() => {

this.$router.push({
name: this.parentRouter
})
}, 300)
},

getTimeSlot () {
this.dateArr = []
let params = {
flowId: this.flowId,
flowProcedureId: this.flowProcedureId,
procedureId: this.procedureId,
campusCode: this.campusCode
}
this.$api.get('/configBodyExam', params,
r => {
this.daylist = r.data
this.getLastData()
r.data.forEach(element => {
let obj = {}
let isfull = ''
let flag = false
if (element.totalNumber - element.useNumber === 0) {
isfull = ' 名额已满'
flag = false
} else {
isfull = '可预约'
flag = true
}
obj = {
'value': element.startDatetime.split(' ')[0] + ' ' + element.startDatetime.split(' ')[1] + '至' + element.endDatetime.split(' ')[1],
'state': isfull,
'num': element.totalNumber - element.useNumber,
'id': element.id,
'flag': flag
}
this.dateArr.push(obj)
})
this.dateArr = this.dateArr.sort(this.sortNumber)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

sortNumber (a, b) {
return Date.parse(a.value.split(' ')[0]) - Date.parse(b.value.split(' ')[0])
},
changeDate (value, flag) {
if (flag) {
this.showDate = false
this.dateValue = value
this.preiod = value.replace('至', '-')
}
},

save () {
let params = {
id: this.id,
flowId: this.flowId,
flowProcedureId: this.flowProcedureId,
procedureId: this.procedureId,
studentId: this.studentId,
preiod: this.preiod,
status: 4
}
this.$api.post('/bodyExamOrder/handle', params,
r => {
this.$vux.loading.show({
text: '加载中,请稍后'
})
setTimeout(() => {
this.$vux.loading.hide()
this.$router.push({
name: 'itemResult'
})
}, 5000)
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getLastData () {
let params = {
'studentId': this.studentId,
'flowId': this.flowId
}
this.$api.get('/bodyExamOrder', params,
r => {
if (r.data.length > 0) {
this.btnText = '重新预约'
var data = r.data[0]
this.id = data.id
this.dateValue = data.preiod.split(' ')[0] + ' ' + data.preiod.split(' ')[1].replace('-', '至')
this.preiod = data.preiod
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/medical.vue